import React from 'react';
import styles from './ValueSlot.module.css';

interface ValueSlotProps {
  type?: 'round' | 'hexagon' | 'boolean' | 'variable' | 'diamond';
  children: React.ReactNode;
  color?: string;
}

export const ValueSlot: React.FC<ValueSlotProps> = ({ type = 'round', children, color }) => {
  const style: React.CSSProperties = color ? { backgroundColor: color, color: 'white' } : {};

  return (
    <span className={`${styles.valueSlot} ${styles[type]}`} style={style}>
      {children}
    </span>
  );
};
